module.exports = __webpack_public_path__ + "static/media/fortlev-solar-logo.972e80b7.png";